import Parse from "parse";
import { useEffect, useState } from "react";
import { Direction } from "../js/parsegenerated";

export function useDirection() {
  const [directions, setDirections] = useState<Direction[]>([]);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    new Parse.Query(Direction).find().then(setDirections);
  }, [reload]);

  return [
    directions,
    () => {
      setReload((x) => x + 1);
    },
  ] as [Direction[], () => void];
}
